import { canteenMenuWidget } from './templates/canteenMenuWidget';
import { equipmentStatusWidget } from './templates/equipmentStatusWidget';
import { exampleWebsiteTemplateWidget } from './templates/exampleWebsiteWidget';
import { hospitalLocationWidget } from './templates/hospitalLocationWidget';
import { medicalReferenceWidget } from './templates/medicalReferenceWidget';
import { medicationInstructionsWidget } from './templates/medicationInstructionsWidget';
import { patientScheduleWidget } from './templates/patientScheduleWidget';
import { patientVitalsWidget } from './templates/patientVitalsWidget';
import { quickNotesWidget } from './templates/quickNotesWidget';
import { staffDirectoryWidget } from './templates/staffDirectoryWidget';
import { staffRosterWidget } from './templates/staffRosterWidget';
import { staffSurveyWidget } from './templates/staffSurveyWidget';
import { xrayViewerWidget } from './templates/xrayViewerWidget';

export interface WidgetConfig {
  id: string;
  title: string;
  content: string;
  x: number;
  y: number;
  w: number;
  h: number;
}

export interface MultilingualWidgetConfig {
  id: string;
  translations: {
    en: {
      title: string;
      content: string;
    };
    de: {
      title: string;
      content: string;
    };
  };
  x: number;
  y: number;
  w: number;
  h: number;
}

export const MULTILINGUAL_WIDGETS: MultilingualWidgetConfig[] = [
  hospitalLocationWidget,
  staffSurveyWidget,
  exampleWebsiteTemplateWidget,
  equipmentStatusWidget,
  staffDirectoryWidget,
  staffRosterWidget,
  canteenMenuWidget,
  medicationInstructionsWidget,
  medicalReferenceWidget,
  patientVitalsWidget,
  quickNotesWidget,
  xrayViewerWidget,
  patientScheduleWidget,
];

export function getLocalizedWidgets(language: 'en' | 'de' = 'en'): any[] {
  return MULTILINGUAL_WIDGETS.map(widget => ({
    id: widget.id,
    title: widget.translations[language].title,
    content: widget.translations[language].content,
    x: widget.x,
    y: widget.y,
    w: widget.w,
    h: widget.h,
  }));
}
